import React, { useEffect } from 'react';
import { parseUrlParams } from 'utils/parseUrlParams';

const MicrobiltComplete = () => {
  useEffect(() => {
    const params = parseUrlParams(window.location.search);
    window.top.postMessage(
      {
        error: false,
        microbiltComplete: true,
        ...params,
      },
      '*'
    );
  }, []);

  return (
    <div className="transition-item wrapper agreement">
      <h3>Microbilt Complete</h3>
    </div>
  );
};

MicrobiltComplete.propTypes = {
};

export default MicrobiltComplete;
